export default __webpack_public_path__ + "static/media/ar-icon.c1774e6c.svg";